export default __webpack_public_path__ + "static/media/6-min.de90e1d3.webp";